export const usedPct = (balance: number, total: number) => {
  const denom = Math.max(total, balance);
  if (denom <= 0) return 0;
  return Math.min(100, Math.floor((100 * (denom - balance)) / denom));
};

export const parseLocalDate = (isoDate: string): Date => {
  const [year, month, day] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const daysUntil = (isoDate: string): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const millis = parseLocalDate(isoDate).getTime() - today.getTime();
  return Math.max(0, Math.round(millis / 86_400_000));
};

export const formatResetDate = (isoDate: string): string =>
  parseLocalDate(isoDate).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });

export const formatCents = (cents: number): string =>
  cents % 100 === 0
    ? `$${(cents / 100).toLocaleString()}`
    : `$${(cents / 100).toFixed(2)}`;

export const formatCentsExact = (cents: number): string =>
  `$${(cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const creditsToValueCents = (
  credits: number,
  rateCentsPer1000: number
): number => Math.ceil((credits * rateCentsPer1000) / 1000);

export const discountPctForCents = (
  brackets: { min_cents: number; discount_pct: number }[],
  cents: number
): number =>
  brackets.reduce(
    (pct, bracket) => (cents >= bracket.min_cents ? bracket.discount_pct : pct),
    0
  );

export const discountedPriceCents = (
  valueCents: number,
  discountPct: number
): number => Math.floor((valueCents * (100 - discountPct)) / 100);

export const toDollarsString = (cents: number): string =>
  cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);

export const sanitizeDollars = (raw: string): string => {
  const cleaned = raw.replace(/[^\d.]/g, '');
  const [whole, ...rest] = cleaned.split('.');
  return rest.length > 0 ? `${whole}.${rest.join('').slice(0, 2)}` : whole;
};
